import { sendClientRequest } from '@/utils/client-request'
import { shopperHeaders } from './shopper-headers'

export const validateGiftCardApi = (vendorId: string, code: string) =>
  sendClientRequest({ url: `/giftCard/validate/${code}`, auth: false, headers: { Vendor: vendorId } as any })

type CreateArgs = {
  vendorId: string
  sessionId: string | null
  isGuest: boolean
  accessToken?: string | null
  body: any
}

export const createGiftCardApi = ({ vendorId, sessionId, isGuest, accessToken, body }: CreateArgs) =>
  sendClientRequest({
    url: '/giftCard',
    method: 'POST',
    auth: false,
    headers: shopperHeaders({ vendorId, sessionId, isGuest, accessToken }),
    body,
  })
